
import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import Form from '../../form/components/Form';
import MailFolderSelect from './MailFolderSelect';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { mailPath } from '../../nav/paths';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
    container: {
        width: '100%',
    },

    select: {
        width: `calc(100% - 100px)`,
    },

    switch: {
        width: 100,
    },
});


const MailFolderFilter = ({ selectedFolder, onChangeFolder }) => {

    const history = useHistory();
    const classes = useStyles();

    const handleChangeFolder = useCallback((values) => {
        if (values.filterByFolder === selectedFolder) {
            return;
        }

        if (values.filterByFolder) {
            onChangeFolder(values.filterByFolder);
            history.push(mailPath);
            return;
        }
    }, [history, onChangeFolder, selectedFolder]);

    return (
        <Grid item xs={12}>
            <Form
                initialValues={{ filterByFolder: selectedFolder }}
                enableReinitialize
                onChange={handleChangeFolder}
                onSubmit={() => {}}
            >
                <Grid container direction="row" wrap="wrap" spacing={2} className={classes.container}>
                    <Grid container direction="row" wrap="wrap" spacing={2}>
                        <Grid item xs={12}>
                            <MailFolderSelect
                                name="filterByFolder"
                                fullWidth
                                label="Ordner"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Form>
        </Grid>
    );
}

MailFolderFilter.propTypes = {
    selectedFolder: PropTypes.string.isRequired,
    onChangeFolder: PropTypes.func.isRequired,
};

export default MailFolderFilter;
